// Catégories des mouvements de fonds (entrées/sorties de caisse) : le POS
// envoie une clé brute (`cafe_the`, `petites_depenses`...) — voir
// pos_clone constants/fundsMovement.js. Libellés dans activite.json >
// fundMovementCategories ; une clé inconnue s'affiche telle quelle.
// L'API renvoie "Sans catégorie" (fund_movements_totals) ou null (journal)
// pour un mouvement sans catégorie.
export const fundMovementCategoryLabel = (t, value) => {
    if (!value || value === "Sans catégorie") {
        return t("fundMovementCategories.none");
    }
    return t(`fundMovementCategories.${value}`, {defaultValue: value});
};
